import React from 'react';
import {
  FdrCustomMapControl,
  FdrMapControlPosition,
} from '@hotelplan/fdr.regular.fusion.fdr-map';
import { createFullScreenControl } from 'components/domain/fdr-map';

type TProps = { onChange: React.Dispatch<React.SetStateAction<boolean>> };

const FdrGeoTripsFullscreenButton: React.FC<TProps> = ({
  onChange,
}: TProps) => {
  return (
    <FdrCustomMapControl
      onCreateControl={createFullScreenControl({ onChange })}
      position={FdrMapControlPosition.RIGHT_TOP}
    />
  );
};

export default FdrGeoTripsFullscreenButton;
